import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed"},[(_vm.company_data && _vm.company_data.status == 'on_trial' && _vm.days > 0 )?_c(VAlert,{attrs:{"app":"","type":"info","dense":"","border":"bottom","icon":"mdi-timer-play-outline"}},[_c('strong',[_vm._v("Período de testes")]),_vm._v(" - "+_vm._s(_vm.setDaysToMsg)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }